/* ============================================
   VERANO — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- COUNTDOWN TIMER ----
  function updateCountdown() {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    const diff = midnight - now;

    if (diff <= 0) return;

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    const hoursEl = document.getElementById('hours');
    const minutesEl = document.getElementById('minutes');
    const secondsEl = document.getElementById('seconds');

    if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');
  }
  setInterval(updateCountdown, 1000);
  updateCountdown();


  // ---- PRODUCT IMAGE SWITCHER ----
  const thumbBtns = document.querySelectorAll('.thumb-btn');
  const mainImage = document.getElementById('product-main-image');

  thumbBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      thumbBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      if (mainImage) {
        mainImage.src = this.dataset.imageUrl;
        mainImage.alt = this.dataset.imageAlt || '';
      }
    });
  });


  // ---- VARIANT SELECTOR ----
  // Reads Shopify's global product JSON to match selected options to a variant
  const variantOptions = document.querySelectorAll('.variant-options');
  const variantIdInput = document.getElementById('variant-id');
  const productForm = document.getElementById('product-form');
  const priceEl = document.getElementById('product-price');
  const addToCartBtn = document.getElementById('add-to-cart');

  if (variantOptions.length && typeof window.productData !== 'undefined') {
    const variants = window.productData.variants;

    variantOptions.forEach(optionGroup => {
      const btns = optionGroup.querySelectorAll('.variant-btn');
      btns.forEach(btn => {
        btn.addEventListener('click', function () {
          btns.forEach(b => b.classList.remove('active'));
          this.classList.add('active');
          updateSelectedVariant();
        });
      });
    });

    function getSelectedOptions() {
      const selected = [];
      variantOptions.forEach(group => {
        const activeBtn = group.querySelector('.variant-btn.active');
        if (activeBtn) selected.push(activeBtn.dataset.value);
      });
      return selected;
    }

    function updateSelectedVariant() {
      const selectedOptions = getSelectedOptions();

      const matchedVariant = variants.find(v => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (matchedVariant) {
        if (variantIdInput) variantIdInput.value = matchedVariant.id;

        // Update price display
        if (priceEl) {
          const price = (matchedVariant.price / 100).toLocaleString('en-US', {
            style: 'currency', currency: 'USD'
          });
          priceEl.textContent = price;
        }

        // Update availability
        if (addToCartBtn) {
          if (matchedVariant.available) {
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.disabled = false;
          } else {
            addToCartBtn.textContent = 'Sold Out';
            addToCartBtn.disabled = true;
          }
        }
      }
    }
  }


  // ---- AJAX ADD TO CART ----
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;

      if (addToCartBtn) {
        addToCartBtn.textContent = 'Adding...';
        addToCartBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => res.json())
        .then(data => {
          if (addToCartBtn) {
            addToCartBtn.textContent = 'Added!';
            setTimeout(() => {
              addToCartBtn.textContent = 'Add to Cart';
              addToCartBtn.disabled = false;
            }, 2000);
          }

          // Update cart count in nav
          return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
          const cartEl = document.querySelector('.nav-cart');
          if (cartEl) cartEl.textContent = `Cart (${cart.item_count})`;
        })
        .catch(err => {
          console.error('Cart error:', err);
          if (addToCartBtn) {
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.disabled = false;
          }
        });
    });
  }


  // ---- COLORWAY SELECTOR (fallback for non-Shopify variant display) ----
  document.querySelectorAll('.colorway').forEach(c => {
    c.addEventListener('click', () => {
      document.querySelectorAll('.colorway').forEach(x => x.classList.remove('active'));
      c.classList.add('active');
    });
  });

});


  // ---- ACCORDION ----
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function () {
      const item = this.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });


  // ---- CART PAGE QTY + REMOVE ----
  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(res => res.json())
    .then(cart => {
      if (quantity === 0) {
        document.querySelector(`[data-key="${key}"].cart-item`)?.remove();
      } else {
        const qtyEl = document.querySelector(`[data-key="${key}"].cart-item .qty-value`);
        if (qtyEl) qtyEl.textContent = quantity;
      }
      const subtotalEl = document.getElementById('cart-subtotal');
      const totalEl = document.getElementById('cart-total');
      const formatted = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      if (subtotalEl) subtotalEl.textContent = formatted;
      if (totalEl) totalEl.textContent = formatted;
      const cartEl = document.querySelector('.nav-cart');
      const stickyCart = document.querySelector('.sticky-cart-count');
      if (cartEl) cartEl.textContent = `Cart (${cart.item_count})`;
      if (stickyCart) stickyCart.textContent = cart.item_count;
      if (cart.item_count === 0) location.reload();
    });
  }

  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      const action = this.dataset.action;
      const qtyEl = this.closest('.cart-item-qty').querySelector('.qty-value');
      let qty = parseInt(qtyEl.textContent);
      qty = action === 'increase' ? qty + 1 : qty - 1;
      updateCartItem(key, Math.max(0, qty));
    });
  });

  document.querySelectorAll('.cart-item-remove').forEach(btn => {
    btn.addEventListener('click', function () {
      updateCartItem(this.dataset.key, 0);
    });
  });

  // ---- STICKY CART: show after nav scrolls out of view ----
(function () {
  const nav = document.getElementById('site-nav');
  const stickyCart = document.querySelector('.sticky-cart');
  if (!nav || !stickyCart) return;

  function onScroll() {
    const navBottom = nav.getBoundingClientRect().bottom;
    if (navBottom < 0) {
      stickyCart.classList.add('visible');
    } else {
      stickyCart.classList.remove('visible');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load in case page is already scrolled
})();